import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import InputDatePicker from 'components/common/InputDatePicker';
import SpAccountManagerDropdown from 'components/dropdowns/SpSalePerson/SpAccountManagerDropdown';
const KpiSummaryFilter = ({
  formData,
  handleChange,
  handleSubmit,
  style,
  displayOption = {},
  isFromManagerPage
}) => {
  return (
    <Card>
      <Card.Body className="bg-light">
        <Row style={style}>
          <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
            <Form.Group>
              <Flex alignItems="center" justifyContent="between">
                <Form.Label style={{ marginBottom: 13 }}>Apply From</Form.Label>
              </Flex>
              <InputDatePicker
                column="date"
                className="mb-3"
                selected={formData?.date}
                handleChange={handleChange}
              />
            </Form.Group>
          </Col>
          {isFromManagerPage && (
            <Col lg={displayOption.col} style={{ paddingBottom: '10px' }}>
              <Form.Label className="fs-0">Account Manager</Form.Label>
              <SpAccountManagerDropdown
                placeholder='Account Manager'
                fieldName="saleId"
                handleChange={(key, value) => handleChange(key, value?.id)}
                selectedOptions={formData?.saleId}
              />
            
            </Col>
          )}
        </Row>
      </Card.Body>
      {displayOption && displayOption.showFooter && (
        <Card.Footer>
          <hr />
          <div className="text-center mt-2">
            <Button color="primary" onClick={handleSubmit}>
              Search
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};
KpiSummaryFilter.propTypes = {
  formData: PropTypes.object,
  displayOption: PropTypes.object,
  handleSubmit: PropTypes.func,
  saveConfig: PropTypes.func,
  style: PropTypes.object,
  handleChange: PropTypes.func,
  searchKeyword: PropTypes.string,
  isParentFullRow: PropTypes.bool,
  isFromManagerPage: PropTypes.bool
};

export default KpiSummaryFilter;
